import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../api/api";
import "./LatestUpdatesPage.css";

const LatestUpdatesPage = () => {
  const [recentItems, setRecentItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);

  // Filters
  const [mainList, setMainList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subList, setSubList] = useState([]);

  const [mainFilter, setMainFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [subFilter, setSubFilter] = useState("");

  useEffect(() => {
    loadUpdates();
  }, []);

  const loadUpdates = async () => {
    try {
      const res = await API.get("/schemes");

      const allSub = res.data.flatMap((scheme) =>
        scheme.categories.flatMap((cat) =>
          cat.subcategories.map((sub) => ({
            mainCategory: scheme.mainCategory,
            categoryName: cat.name,
            subcategoryName: sub.name,
            updatedAt: sub.updatedAt || scheme.updatedAt,
          }))
        )
      );

      const sorted = allSub.sort(
        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
      );

      setRecentItems(sorted);
      setFilteredItems(sorted);

      // Build main list
      const mainSet = [...new Set(sorted.map((s) => s.mainCategory))];
      setMainList(mainSet);
    } catch (err) {
      console.error("Error loading updates:", err);
    }
  };

  // ================= FILTER HANDLER =================
  useEffect(() => {
    let items = [...recentItems];

    if (mainFilter) {
      items = items.filter((x) => x.mainCategory === mainFilter);
      const cats = [...new Set(items.map((a) => a.categoryName))];
      setCategoryList(cats);
    } else {
      setCategoryList([]);
      setCategoryFilter("");
      setSubList([]);
      setSubFilter("");
    }

    if (categoryFilter) {
      items = items.filter((x) => x.categoryName === categoryFilter);
      const subs = [...new Set(items.map((a) => a.subcategoryName))];
      setSubList(subs);
    } else {
      setSubList([]);
      setSubFilter("");
    }

    if (subFilter) {
      items = items.filter((x) => x.subcategoryName === subFilter);
    }

    setFilteredItems(items);
  }, [mainFilter, categoryFilter, subFilter]);

  return (
    <div className="container my-4">
      <h2 className="fw-bold page-title text-center mb-4">🔥 Latest Updates</h2>

      {/* ================= FILTERS ================= */}
      <div className="row g-3 mb-4">
        {/* Main Category */}
        <div className="col-md-4">
          <select
            className="filter-select"
            value={mainFilter}
            onChange={(e) => {
              setMainFilter(e.target.value);
              setCategoryFilter("");
              setSubFilter("");
            }}
          >
            <option value="">Filter by Main Category</option>
            {mainList.map((m, i) => (
              <option key={i} value={m}>
                {m}
              </option>
            ))}
          </select>
        </div>

        {/* Category */}
        <div className="col-md-4">
          <select
            className="filter-select"
            disabled={!categoryList.length}
            value={categoryFilter}
            onChange={(e) => {
              setCategoryFilter(e.target.value);
              setSubFilter("");
            }}
          >
            <option value="">Filter by Category</option>
            {categoryList.map((c, i) => (
              <option key={i} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>

        {/* Subcategory */}
        <div className="col-md-4">
          <select
            className="filter-select"
            disabled={!subList.length}
            value={subFilter}
            onChange={(e) => setSubFilter(e.target.value)}
          >
            <option value="">Filter by Subcategory</option>
            {subList.map((s, i) => (
              <option key={i} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* ================= UPDATE LIST ================= */}
      <div className="latest-container">
        {filteredItems.length === 0 ? (
          <p className="text-muted text-center">No updates found.</p>
        ) : (
          filteredItems.map((item, i) => (
            <Link
              to={`/category/${encodeURIComponent(item.categoryName)}`}
              className="latest-card-link"
              key={i}
            >
              <div className="latest-card">
                <div className="update-icon">
                  <i className="bi bi-bell-fill"></i>
                </div>

                <div className="update-info">
                  <p className="latest-item-text">
                    {item.categoryName} → {item.subcategoryName}
                    <span className="new-badge ms-2">NEW</span>
                  </p>

                  <p className="latest-date">
                    Updated:{" "}
                    {new Date(item.updatedAt).toLocaleDateString("en-IN")}
                  </p>
                </div>

                {/* VIEW BUTTON */}
                <div className="update-btn-wrap">
                  <button className="view-btn">View</button>
                </div>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default LatestUpdatesPage;
